import { RootState } from "@/store/types";
import { ActionTree } from "vuex";
import { LogState } from "@/services/logging/types";

export const actions: ActionTree<LogState, RootState> = {
    addLog(context, payload) {
        context.commit("addLog", payload);
    },
    shipLogs(context) {
        context.commit("shipLogs");
    },
    updateLogLevels(context, payload) {
        context.commit("updateLogLevels", payload);
    }
};
